const colors = require("../styles/colors");

module.exports = {
  pathPrefix: "/",
  siteTitle: "Baublog zum Neubau/Anbau für die Ganztagsbetreuung der IBGS e.V.",
  siteLongTitle: "Neubau / Anbau für die Ganztagsbetreuung. Baublog der IBGS e.V.",
  siteUrl: "https://blog.ibgs-luebeck.de",
  siteLanguage: "de",
  siteLogo: "/logos/logo-1024.png",
  siteDescription: "Hier berichten Kinder, MitarbeiterInnen und andere Beteiligte über den laufenden Neubau der IBGS e.V.",
  // manifest.json
  manifestName: "Neubau/Anbau der Ganztagsbetreuung der IBGS e.V.",
  manifestShortName: "IBGS Baublog",
  manifestStartUrl: "/",
  manifestBackgroundColor: colors.first,
  manifestThemeColor: colors.firstLight,
  manifestDisplay: "standalone",
  // author note
  authorName: "IBGS e.V.",
  // texts
  copyright:
    "©2018 IBGS e.V."
};



// WEBPACK FOOTER //
// ./src/utils/siteConfig.js